import { css } from '@emotion/react';
import usingPhoneBackground from '@assets/images/using_phone_background.png';
import { Gray, White } from '@constants/color';

export const container = css({
  width: 1920,
  height: 1080,
  display: 'flex',
  backgroundImage: `url(${usingPhoneBackground})`
});

export const leftSideContainer = css({
  width: 1152,
  height: 952,
  padding: 64
});

export const rightSideContainer = css({
  width: 512,
  backgroundColor: Gray.Gray90,
  padding: '180px 64px 64px'
});

export const title = css({
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px',
  color: White.White10,
  paddingTop: 80
});
